export default "__VITE_ASSET__N21iQfUJ__"